module.exports = new __parcel__URL__("under.b02e8686.jpg").toString();